// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class BackgroundManagerNotOpenError extends Error {
    constructor(message) {
        super(`BackgroundManagerNotOpenError: ${message}`);
    }
}

export { BackgroundManagerNotOpenError };
//# sourceMappingURL=BackgroundManagerNotOpenError.mjs.map
